module.exports = __webpack_public_path__ + "img/img-a012048f.17ccfa3b.png";